import {queryGqlApi} from "../../../graphql/queryGqlApi";
import {notifByUser} from "../../../graphql/queries";
import {ModelSortDirection} from "../../../API";
import { IDataClientService } from '../../../platform/services/data/DataClientService';
import { IAuthService } from '../../../platform/services/auth/AuthService';

export const listNotifications = (
    dataClientService: IDataClientService,
    authService: IAuthService,
    tenantId: string,
    currentUserId: string,
    nextToken?: string, 
    limit?: number
): Promise<any> => {
    return queryGqlApi(
        notifByUser,
        {
            ownerId: tenantId,
            userIdCreatedAt: {
                beginsWith: {
                    userId: currentUserId,
                }
            },
            sortDirection: ModelSortDirection.DESC,
            limit: limit,
            nextToken: nextToken
        },
        dataClientService,
        authService,
        'main'
    );
}
